import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OopsGemTimePickerComponent } from './oops-gem-timepicker.component';

@NgModule({
  declarations: [
    OopsGemTimePickerComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [OopsGemTimePickerComponent]
})
export class OopsGemTimePickerModule { }
